import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-count-card',
    templateUrl: './count-card.component.html',
    styleUrls: ['./count-card.component.scss'],
})
export class CountCardComponent {
    @Input() title: string = ''; // Title of the card
    @Input() totalCount: number = 0; // Total count value
    @Input() progressBarPercentage: number = 0; // Progress bar value
    @Input() activeLabel: string = 'Active'; // Label for the active data
    @Input() additionalTitle: string = 'Upcoming'; // Label for the active data
    @Input() activeCount: number = 0; // Count for the active data
    @Input() activeColor: string = '#9BE8FF'; // Color for the active indicator
    @Input() upcomingLabel: string = 'Upcoming'; // Label for the upcoming data
    @Input() upcomingCount: number = 0; // Count for the upcoming data
    @Input() upcomingColor: string = '#FDCD16'; // Color for the upcoming indicator
    @Input() remainingColor: string = '#e2e8f0';
    @Input() selectedFilter: string | null = null; // Selected filter for highlighting
    @Output() filterClick = new EventEmitter<any>();

    ngOnInit() {
        this.setProgressBarColor();
    }

    setProgressBarColor() {
        if (this.additionalTitle === 'Upcoming') {
            document.documentElement.style.setProperty(
                '--progress-bar-color',
                '#FDCD16'
            ); // Yellow
            this.upcomingColor = '#FDCD16';
        } else {
            document.documentElement.style.setProperty(
                '--progress-bar-color',
                '#fd3116'
            ); // Red
            this.upcomingColor = '#fd3116';

        }
    }

    get activeProgressPercentage(): number {
        return this.totalCount > 0 ? this.calculateProgressPercentage(this.activeCount, this.totalCount) : 0;
    }

    get upcomingProgressPercentage(): number {
        return this.totalCount > 0 ? this.calculateProgressPercentage(this.upcomingCount, this.totalCount) : 0;
    }

    get remainingProgressPercentage(): number {
        if (this.totalCount === 0) {
            return 100; // Default to 100% gray when there are no students
        }
        const allocatedCount = (this.activeCount || 0) + (this.upcomingCount || 0);
        const remainingCount = Math.max(0, this.totalCount - allocatedCount);
        return this.calculateProgressPercentage(remainingCount, this.totalCount);
    }

    private calculateProgressPercentage(part: number, total: number): number {
        return total ? (part / total) * 100 : 0;
    }

    onFilterClick(filterName: string, filterType: string) {
        this.filterClick.emit({
            filterName: filterName,
            filterType: filterType
        });
    }
}
